import { Box, Drawer, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { FilterGroup4 } from "./filter-groups/FilterGroup4";
import { FilterGroup3 } from "./filter-groups/FilterGroup3";
import { FilterGroup2 } from "./filter-groups/FilterGroup2";
import { FilterGroup1 } from "./filter-groups/FilterGroup1";
import { FilterGroup6 } from "./filter-groups/FilterGroup6";
import { FilterGroup5 } from "./filter-groups/FilterGroup5";

type FilterDrawerProps = {
  open: boolean;
  onClose: () => void;
  isPendingApprove: boolean;
};

export const FilterDrawer = (props: FilterDrawerProps) => {
  const { open, onClose, isPendingApprove } = props;
  const { translate } = useTranslation(
    "pages.inventoryManagement.inventory.list.filters",
  );

  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <Box
        sx={{ height: "100%", maxHeight: "100vh" }}
        display="flex"
        flexDirection="column"
        px={2}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={2}
        >
          <Typography variant="h6">{translate("title")}</Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
        <Box flex="1" sx={{ overflowY: "scroll" }}>
          <FilterGroup1 isPendingApprove={isPendingApprove} />
          <FilterGroup2 />
          <FilterGroup3 />
          <FilterGroup4 />
          <FilterGroup5 />
          <FilterGroup6 />
        </Box>
      </Box>
    </Drawer>
  );
};
